const BouncingDots = ({ message }) => {
  return (
    <div className='flex flex-col items-center gap-3 py-6'>
      <div className='flex gap-2'>
        <div className='w-3 h-3 bg-blue-400 rounded-full animate-bounce' style={{ animationDelay: '0ms' }} />
        <div className='w-3 h-3 bg-blue-400 rounded-full animate-bounce' style={{ animationDelay: '150ms' }} />
        <div className='w-3 h-3 bg-blue-400 rounded-full animate-bounce' style={{ animationDelay: '300ms' }} />
      </div>
      {message && <p className='text-sm text-gray-500'>{message}</p>}
    </div>
  )
}

export default BouncingDots
